import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Stage 6 PR #65 — Sentry error reporting. Initialised before render so
// the integration patches React's error boundary correctly. Sentry is silent
// if REACT_APP_SENTRY_DSN isn't set, which is the right behaviour for dev.
const sentryDsn = (process.env.REACT_APP_SENTRY_DSN || "").trim();
if (sentryDsn) {
  // Dynamic import so the SDK is only loaded when configured — keeps the
  // dev bundle small and avoids any error if the package isn't installed
  // in some environments.
  import("@sentry/react").then((Sentry) => {
    try {
      Sentry.init({
        dsn: sentryDsn,
        environment:
          process.env.REACT_APP_SENTRY_ENVIRONMENT ||
          (window.location.hostname.includes("solaraglobal") ? "production" : "development"),
        release: process.env.REACT_APP_SENTRY_RELEASE,
        tracesSampleRate: 0.1,
        // Replays are optional and require extra setup; leave off for now.
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        // Don't send anything in dev unless explicitly opted in.
        enabled: process.env.NODE_ENV !== "test",
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn("Sentry init failed", err);
    }
  }).catch((err) => {
    // eslint-disable-next-line no-console
    console.warn("Sentry SDK not available", err);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
